import { HANDLE_DRAWER } from "../../types";

export function handleDrawer(isOpen: boolean) {
  return {
    type: HANDLE_DRAWER,
    payload: isOpen,
  };
}
